import { z } from 'zod'
import { OrganizationIdSchema } from '../unique-id.models.ts'

import { TeamIdSchema } from '../unique-id.models.ts'

export const FinanceEntityIdSchema = z.union([
  OrganizationIdSchema,
  TeamIdSchema,
])

export type FinanceEntityId = z.infer<typeof FinanceEntityIdSchema>

export const FinanceEntityId = (id: string): FinanceEntityId => {
  return FinanceEntityIdSchema.parse(id)
}
